<template>
    <img src="@/assets/bgLocked.png" cover class="full-height-image" alt="lock">
    <v-container fluid class="pa-0 ma-0" >
        <img src="@/assets/Bg element.png" cover class="full-height-image" alt="lock1"/>
        <v-row style=" width: 100%; display: flex; justify-content: end; align-items: center;">
            <v-col
                cols="12"
                class="login-scroll-container"
                style="padding: 0; overflow-y: hidden"
            >
                <div class="login-form-container">
                <v-row
                    align="center"
                    justify="end"
                    class="img-intersection2"
                    style="height: auto; width: 100%;"
                >
                    <v-col cols="10" lg="6">
                        <div class="mb-1" style="justify-content: center; align-items: center; display: flex;">
                            <div class="logo-container">
                                <img 
                                    alt="Fusion Logo"
                                    :src="logo"
                                    width="100" height="60"
                                />
                                <div class="label-version mr-2">
                                    {{ "Version R" + versioning }}
                                </div>
                            </div>
                        </div>

                    <div>
                        <v-form class="form">
                        <div class="form-group">
                            <v-text-field
                                variant="plain"
                                id="username-login"
                                name="username"
                                type="text"h
                                disabled
                                hide-details="true"
                                class="input-field"
                            >
                            <!-- Floating placeholder text -->
                            <template #prepend-inner>
                                <span
                                class="floating-placeholder"
                                >
                                Username<span style="color: red; margin-left: 6px;">*</span>
                                </span>
                            </template>

                            <!-- Right side icon -->
                            <template #append-inner>
                                <v-img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARwSURBVHgB7VlLUhsxEG3Mr4oNzgkynCDmBLFPgFnyK+wTxJwAcwLiE9gUvyXmBJmcIM4JUG7gbKjin/eMxohhpPlowopX5dLMqCW9abe6Wz0iH3gfzEhOHB8f12dmZmpzc3OfHx4eqlIQs7Oz4/v7+z9PT0+jnZ2dMM/YzKRPT0+/oemCcGGiDiiQP9ja2hpkEU4l3e/3q4uLixe4rMv/R3hzc7PebrfHLqE5SQEI/0BTMyd+fHy8hGZUpVJRt7e3Y8kJmFbAlmaGOb7isqm76nq9Vdd4p6bPz8/3Qa7La7RjkF3Pa39ZwH0C8heR6WlT6drkraRhFgHe+iq6x0SrmGgkDiTZPV8W9webm5vfU8bWIPdL345hJis2M6nYJllYWKhH15hskEZYyzXjG1Xfr6WN5fzUsL7lPmrZZCsOAtOF4JqOJAPgAnto+HIq9utlGQ/zC431v9jkXBtxqjGQTtUyAXsfohlKQXAd+O/JNbRes8lVHHME0UWaCyoLsXWs8cBFOsK7EDag0gRS/bTkJE2vE21i2CW9wAgaVFIispDOBPpa2OO+xCInvICcnZ0x0rXLIp/FPFJB/wzCjGR1iwgj3RWDlZQAb9Ig3IIZmIFD4dfD7m/Ls6tTUQejK7TeFE94mwcIm9rrIfJ1YiIdvFjXkIPZ90Mfj+SlaWpZXlzjMIHwBDqPCPVtFRvVS9u+5jENADoaWmH2M7sTD3iRNvOMpaWlK5cs0tGRMW5ZPFCK9yCur69XXP0I0YGUBC/SSHCm2oMmd12yZj/G/RQPeJG+u7sbMF/mNdoW3FkicT5n/3TRSiUUD3i5PLqtk5OTA9jooX40QACpM5XFTyGgMLFfMwkzZ4aXUeIBb5ve3t5mYJnm2yTI6KhPPRcmYcq5jlFZUcpGhOZa+tShkvq1Ce1RTkpAaQkTNQjTGGCTTYo5ILqM9i+LMTixD8vMyb1JMxVlSYCn9I2NDYVHA4scI2HA6yznTRcKkWYaOj8/vwatMhwHfAYPoeQ593hz6o6f0ikLDzKE97ksUpLIRdrMmUE43h3gdwhCJDhiIUfX+poJpbQA4zuYq8MXQK7dyJNrZ96I9LWWnDmU14fZgERJCmRbMcKhvCROU3l6GpuPl6Kkabfy2lZHILUHDX2COTTwW4dWG5JwEteeI2S/lm3gRVZ0vq0M0QELNnieWuC0Vpjw5vSzgb4N5UXDR2mui4vjpaowkTE8h3J5DqwzQLObsI7COon5jMumzYXqxkQtSUEe74B/qwPzYBEykNemp2xjXObxO+HZpZQM/gswiTfz0sfbxlhJmxlcBNhl4eqRC1hrmOVZBCtpM4OLkLU8lhdJ87oyQStpvXnMI9QYkc/rmGRDfF7mMTq6JiL18wV2N2vG5qRDJvHMKXjDFFRyAuG8CptlgAmgUVZn60b3CJvd+SUgNSIyWsW+uTSx0PQ0HVU5iwDzxB9NvrmkjcvzdaulaxeBlIysXwsiFP6OCC0FTD+lIOjSYB6qyHfED7wX/gFNHzkE/nXH0QAAAABJRU5ErkJggg=="
                                width="20"
                                height="20"
                                contain
                                class="field-icon"
                                ></v-img>
                            </template>
                            </v-text-field>
                        </div>

                        <div class="form-group">
                            <v-text-field
                            id="password-login"
                            name="password"
                            variant="plain"
                            :type="show1 ? 'text' : 'password'"
                            hide-details="true"
                            disabled
                            class="input-field"
                            >
                            <!-- Floating placeholder text -->
                            <template #prepend-inner>
                                <span
                                class="floating-placeholder"
                                >
                                Password<span style="color: red; margin-left: 6px;">*</span>
                                </span>
                            </template>

                            <!-- Right-side password toggle icon -->
                            <template #append-inner>
                                <v-img
                                @click="show1 = !show1"
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANhSURBVHgB7ZlbctowFIaPCZPkKaUrqLOC0hXU2UHymNsAK2hYQWEFoSsAhgEeW1YQdhC6gngHpTwBw6X/SaVUVWxLNoLpdPhnGF0syZ+Pj6QjQ7TXXv+XPL2i1+uVkNQ8z2tdXl7WyVLNZrNweHh4juxH9A1E9Ri/cL1eD66vr1vkSFHQj0iKzxc9r2YD3u12y0ju0b6Q0Izh6y7gc3rFarVqyzxuUuv3+5+TBuDrgG0agFk+tzONZ6NX0Dc3Nw22iCwngXM9X1fajrkvfh9ms9npcrk8gxGquBTajGcrL+4CXjn79cvguquwDx8dHf1QurQBelepVMb6WKJtA9mSrOMHur29HZJLaBO4AGH/9/H7dnV1dUEGYb48IAlEcYg+Z5RBuaSLmDS1OFdhi+IhzmCxC1i4QhZCe7VdwA9OGeTZNDK5Shqp1oYRKllWk5xNoySLpxX6fleKPmWQFTTLIfiYNpQ1NMulxTdRKmgWgyNJtQG5VmpoFkBDrbxT8EzQUdoluAvoUGZ2BW61TrOwVhcPDg5KiCXOAVeQARLHG3qwFLWOix30K9oXtb4hfqPpdFrHhhXasFhZGsCfMPAjgO/od7RWUABf7WpRFs/n8wGSIKJvEe3LeKAn27dkhO50OnyjBqWUDr5YLIakuFJcH74fGWR0Dy3IGSHWqAIgjGuP00vZEB36anu8AR9ud0/i4EEWgVQitB5+AuAUACEZlDZW0e+DAOxtVIgrlegex8fHqr+GNsCstDunAAxl+eTk5A0lyNk6rWubW36etiCeTLlczsdqM0RK0lUEOGUNa6WcW5onLibWAx9iOQX0O8B+kdddWNwptIAJ1Dpeg5GMLVwllJnJZPKTEuQUGjDnSnEoM7B6yeTj4ijGb+QiaeVgufbpuDPfMwSDYzmM9HGxMt2RhVxbuq0UA6V+IPMuVhWn0PP5nLf7tlY9FAeHF20K7hSafRFbcJk/xPBJm9O4LXkT8MRtHIP4GOxJFEMAnJJjZfk8sbUd0VZZLJ4IjcBcXXr8rF+ETMJcaKllE7jz0DStIkLTP3AxrmKE5jiCt2PakWDlFmDLSlUVc+mvQ4jRp/lzrOpzW1YVPl7R7lfSG1kfbMVKUkP2PcXvfFk1YAsDeCQrxKpScvWXx157/cv6BRGkXFdsSf96AAAAAElFTkSuQmCC"
                                width="20"
                                height="20"
                                alt="img"
                                class="field-icon"
                                contain
                                ></v-img>
                            </template>
                            </v-text-field>
                        </div>
                        </v-form>
                    </div>

                    <div class="d-flex align-center justify-center mt-1" style="height: 20px; color: #646464; gap: 70px;">
                        <v-checkbox
                            :label="$t('rememberme')"
                            id="remember-me-login"
                            hide-details
                            disabled
                            density="compact"
                            class="remember-check"
                        ></v-checkbox>

                        <a
                        class="forgotPassword"
                        id="forgot-password-login"
                        >
                        {{ $t("forgotPwd") }}
                        </a>
                    </div>


                    <v-btn
                        id="login-button"
                        class="login"
                        style="font-weight: 600;"
                    >
                        <span style="font-weight: 600;">{{ $t("login") }}</span>
                    </v-btn>

                    <div class="hr-or">
                        <hr style="flex: 1; border: 1px solid #A6A6A6;" />
                        <span style="margin: 0 15px; color: #171717; font-size: 10px;">{{ $t('orDivider') }}</span>
                        <hr style="flex: 1; border: 1px solid #A6A6A6;" />
                    </div>

                    <div class="d-flex justify-center gap-5" id="sign-in">
                        <div
                        class="sign-in-microsoft"
                        style="width: 100px; justify-content: space-around;"
                        >
                        <v-btn               
                            class="btn-sign-in"
                            id="login-microsoft-button"
                        >
                            <div class="d-flex align-center">
                            <img width="13" height="10" src="@/assets/logos_microsoft-icon.svg" alt="Microsoft" />
                            <span style="font-size: 5px; font-weight: 500;">{{ $t("loginMicrosoft") }}</span>
                            </div>
                        </v-btn>
                        </div>

                        <div
                        class="sign-in-authentik"
                        style="width: 100px; gap: 10px;"
                        >
                        <v-btn
                            class="btn-sign-in"
                            id="login-authentik-button"
                        >
                        <img width="13" src="@/assets/authentik_icon.svg" alt="Authentik" />
                        <span style="font-size: 5px; font-weight: 500;">{{ $t("loginAuthentik") }}</span>
                        </v-btn>
                        </div>
                    </div>
                    </v-col>
                </v-row>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { version } from '../../package.json';

export default {
    props: {
        logo: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            versioning: version,
        };
    },
}

</script>

<style scoped>

.forgot {
  width: 10rem;
}

.login {
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(90deg, #C32E0E, #F67760) !important;
  color: #ffffff;
  font-size: 10px;
  gap: 10px;
  height: 25px;
  margin-top: 10px;
}

.hr-or{
  display: flex;
  align-items: center;
  text-align: center;
  width: 57%;
  margin-top: 5px;
  margin-bottom: 5px;
}

.form {
  min-width: 50%;
}

.img-intersection {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.login-scroll-container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* สำหรับ iOS */
}

.login-form-container {
  position: relative;
  min-height: 100%;
}

#sign-in {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 28px;
  margin-top: 1rem;
}

.sign-in-microsoft, .sign-in-authentik {
  width: 65%;
  justify-content: space-around;
  display: flex;
}

.btn-sign-in {
  width: 100%;
  width: 100px;
  border-radius: 8px;
  height: 30px;
  background-color: white !important;
  box-shadow: none !important;
  border: 1px solid #C9C9C9 !important;
}
.btn-sign-in :deep(.v-btn__content),
.btn-sign-in span {
  text-transform: none !important;
}

/* Custom scrollbar สำหรับ webkit browsers (Chrome, Safari) */
.login-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.login-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.login-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}

:deep(.v-input__control .v-input__slot .v-text-field__slot input) {
  font-size: 16px !important;
}

.form-group {
  text-align: left;
  width: 100%;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #ffffff;
}

.form-group input {
  width: 100%;
  border: 1px solid #C9C9C9 !important;
  padding: 5px !important;
  border-radius: 30px;
  font-size: 10px;
}

.form-group input:focus {
  border: #007bff;
}
.input-field :deep(.v-field__input) {
  padding: 4px 8px !important;
}
.input-field :deep(.v-field) {
  max-height: 40px !important;
  min-height: 40px !important;
}

.forgotPassword {
  color: #001763;
  font-weight: 600;
  font-size: 8px;
  text-decoration: underline;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.user-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.18);
}

.user-image img {
  width: 100%;
  height: auto;
}

.changeAccount {
  position: absolute;
  bottom: 10px;
  font-size: 18px;
  margin-top: 10px;
  text-decoration: none;
  color: #007bff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.bg-image-container {
  position: relative;
  overflow: hidden;
}

.full-height-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.forgot-container {
  margin-top: 20px;
  align-items: center;
}

.img-chat {
  display: flex;
  justify-content: center;
  align-items: center;
}

.forgot-buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 10px;
  gap: 12px;
  margin-top: 16px;
}

.forgot-input {
  width: 100%;
  border-radius: 12px;
  font-size: 14px;
}

.remember-check {
    font-size: 8px;
}
.remember-check :deep(.v-label) {
    font-size: 8px;
}

.username-filled :deep(.v-field__input) {
  transform: translateY(2px);
  padding: 4px;
  left: 12px;
  cursor: pointer !important;
}

.field-icon {
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  margin-right: 12px;
  margin-top: -6px;
}

/* Placeholder text */
.floating-placeholder {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 10px;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-field {
    margin-top: 10px;
    margin-bottom: 0px;
    border-radius: 10px;
    border: 1px solid #C9C9C9 !important;
    background-color: white !important;
}

/* Hide Vuetify's native placeholder */
.v-field__input::placeholder {
  opacity: 0;
}
.logo-container {
  position: relative;
  display: inline-flex;
  flex-direction: column;
}
.label-version {
  display: flex;
  padding: 6px 12px 4px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: var(--main, #C32E0E);
  font-size: 6px;
  font-style: normal;
  font-weight: 500;
  border-radius: 24px;
  background: linear-gradient(91deg, rgba(246, 119, 96, 0.10) 1.14%, rgba(195, 46, 14, 0.10) 46.51%, rgba(246, 119, 96, 0.10) 120.41%);
  position: absolute;
  bottom: 2px;        /* adjust to fine-tune placement */
  right: -75px;           /* align to bottom-right of logo */
}
</style>
